import { render, staticRenderFns } from "./interface-source-dialog.vue?vue&type=template&id=1b5b310b&scoped=true&"
import script from "./interface-source-dialog.vue?vue&type=script&lang=js&"
export * from "./interface-source-dialog.vue?vue&type=script&lang=js&"
import style0 from "./interface-source-dialog.vue?vue&type=style&index=0&id=1b5b310b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b310b",
  null
  
)

export default component.exports